import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// ASSETS
import oval from '@/assets/images/home/oval.svg';

export const WhoWeAreContainer = styled.section`
  padding: 0;

  .page-content {
    position: relative;
    padding-right: 15px;
    padding-left: 15px;
    &:after {
      content: '';
      position: absolute;
      top: 50px;
      right: -50px;
      left: 0;
      bottom: 0;
      z-index: -1;

      ${breakpoints.up('sm')} {
        background-image: url(${oval});
        background-position: right top;
        background-repeat: no-repeat;
      }
    }

    ${breakpoints.down('xs')} {
      .MuiGrid-container {
        flex-direction: column-reverse;
      }

      .MuiButton-root {
        width: 100%;
      }
    }
  }

  .who-we-are {
    &__image {
      max-width: 597px;
      width: 100%;
      height: auto;
      ${breakpoints.down('xs')} {
      }
    }
  }
`;

export default WhoWeAreContainer;
